import React, { Component } from "react";
import axios from "axios";
import cookie from "react-cookies";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Select from "react-select";
import update from "immutability-helper";
import { validated } from "react-custom-validation";
import $ from "jquery";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { GET_FORMPOST, GET_DETAILDATA } from "../../../actions";
import { apiUrl, clientheaderconfig } from "../../Helpers/Config";
import {
  showLoader,
  hideLoader,
  showAlert,
  isEmpty,
  isSingleSelect,
  uploadFile,
  removeFile,
} from "../../Helpers/SettingHelper";
import PageLoader from "../../Helpers/PageLoader";
import Header from "../Layout/Header";
import Topmenu from "../Layout/Topmenu";
import Footer from "../Layout/Footer";
import Editor from "../Layout/Editor";

var module = "category";
var moduleName = "Categories";
var modulePath = "/clientpanel/catalog-categories";
var dayList = [
  { day: "Mon", checked: "No", start: "", end: "" },
  { day: "Tue", checked: "No", start: "", end: "" },
  { day: "Wed", checked: "No", start: "", end: "" },
  { day: "Thu", checked: "No", start: "", end: "" },
  { day: "Fri", checked: "No", start: "", end: "" },
  { day: "Sat", checked: "No", start: "", end: "" },
  { day: "Sun", checked: "No", start: "", end: "" },
];
class Form extends Component {
  constructor(props) {
    super(props);
    var editID = "";
    if (
      this.props.match.path === "/clientpanel/catalog-categories/edit/:EditID"
    ) {
      editID = this.props.match.params.EditID;
    }
    this.state = {
      editID: editID,
      pageloading: false,
      clientdata: {
        categoryName: "",
        categoryOutletID: [],
        categoryAvailabilityID: [],
        categoryCustomTitle: "",
        categoryShortDescription: "",
        categoryLongDescription: "",
        categorySequence: "",        
        categoryLeadTime: "",
        categoryImage: "",
        categoryStatus: "",
        categoryTimeAvailability: dayList,
      },
      btndisabled: false,
      loading: true,
      tatList: [],
      availabiltyList: [],
      formpost: [],
      companyDetail: [],
      outletList: [],
    };
    this.handleChange = this.handleChange.bind(this);
  }
  componentDidMount() {
    this.loadAvailabilty();
    this.loadOutlet();
    if (this.state.editID !== "") {
      var params = {
        params:'' ,
        url: `${apiUrl}${module}/detail/${this.state.editID}`,
        type: "client",
      };
      this.setState({ pageloading: true });
      this.props.getDetailData(params);
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.state.formpost !== nextProps.formpost &&
      this.props.formpost != nextProps.formpost
    ) {
      if (nextProps.formpost.length > 0) {
        hideLoader("submit_frm", "class");
        var errMsg = nextProps.formpost[0].message;
        if (nextProps.formpost[0].status === "ok") {
          showAlert("Success", errMsg, "success", "No");
          var history = this.props.history;
          setTimeout(function () {
            history.push(modulePath);
          }, 1000);
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
      }
    }
    if (
      this.state.companyDetail !== nextProps.detaildata &&
      this.state.editID !== ""
    ) {
      this.setState({ companyDetail: nextProps.detaildata }, function () {
        if (nextProps.detaildata[0].status === "ok") {
          var result = nextProps.detaildata[0].result;
          var categoryStatus =
            result.categoryStatus == "A" ? "Active" : "In Active";
          var status =
            result.categoryStatus !== "" && result.categoryStatus !== null
              ? {
                  label: categoryStatus,
                  value: result.categoryStatus,
                }
              : "";

          var updcategoryTimeAvailability = [];
          if (result.categoryTimeAvailability!=="" && result.categoryTimeAvailability!==null) {
            updcategoryTimeAvailability = JSON.parse(result.categoryTimeAvailability);
          } else {
            updcategoryTimeAvailability = dayList;
          }
          var clientupdatedata = {
            categoryName: result.categoryName,
            categoryOutletID: result?.categoryOutletID ?? [],
            categoryAvailabilityID: result.categoryAvailabilityID,   
            categoryCustomTitle: result.categoryCustomTitle,
            categoryShortDescription:
              result.categoryShortDescription !== "" &&
              result.categoryShortDescription !== null
                ? result.categoryShortDescription
                : "",
            categoryLongDescription:
                result.categoryLongDescription !== "" &&
                result.categoryLongDescription !== null
                  ? result.categoryLongDescription
                  : "",
            categorySequence: result.categorySequence,
            categoryLeadTime: result.categoryLeadTime,
            categoryImage: result.categoryImage,
            categoryTimeAvailability: updcategoryTimeAvailability,
            categoryStatus: status,
          };
          this.setState({ clientdata: clientupdatedata, pageloading: false });
        } else {
          this.setState({ pageloading: false });
          this.props.history.push(modulePath);
          showAlert("Error", "Invalid Category", "error");
        }
      });
    }
  }
  loadOutlet() {
    var urlShringTxt = apiUrl + "outlet/dropDownList" ;
    axios.get(urlShringTxt, clientheaderconfig).then((res) => {
      if (res.data.status === "ok") {
        this.setState({ outletList: res.data.result });
      }
    }).catch((e) => {
      console.log(e)
    });
  }
  loadAvailabilty() {
    var urlShringTxt = apiUrl + "availability/companydropDownList";
    axios.get(urlShringTxt, clientheaderconfig).then((res) => {
      if (res.data.status === "ok") {
        this.setState({ availabiltyList: res.data.result });
      }
    }).catch((e) => {
      console.log(e)
    });
  }

  sateValChange = (field, value) => {
    this.setState({ btndisabled: value });
  };

  handleChange(checked, name) {
    this.setState({ checked });
  }

  fieldChange = (field, value) => {
    this.setState(
      update(this.state, { clientdata: { [field]: { $set: value } } })
    );
  };

  handleSubmit = () => {
    showLoader("submit_frm", "class");
    var postData = this.state.clientdata;

    let categoryOutletID = postData.categoryOutletID.length > 0 ? postData.categoryOutletID.map(item => item.value) : [];
    let categoryAvailabilityID = postData.categoryAvailabilityID.length > 0 ? postData.categoryAvailabilityID.map(item => item.value) : [];
    
    var postObject = {
      categoryName: postData.categoryName,
      categoryOutletID:postData.categoryOutletID.length > 0 ? categoryOutletID.join(",") : "",
      categoryAvailabilityID:categoryAvailabilityID.length > 0 ? categoryAvailabilityID.join(",") : "",
      categoryCustomTitle: postData.categoryCustomTitle,      
      categoryShortDescription: postData.categoryShortDescription,
      categoryLongDescription: postData.categoryLongDescription,
      categorySequence: postData.categorySequence,
      categoryLeadTime: postData.categoryLeadTime,
      categoryImage: postData.categoryImage,
      categoryTimeAvailability: JSON.stringify(postData.categoryTimeAvailability),
      categoryStatus:postData?.categoryStatus?.value ?? "A",
    };

    var post_url = module;
    let method = "post";
    if (this.state.editID !== "") {
      post_url = `${module}/${this.state.editID}`;
      method = 'update';
    }
    this.props.getFormPost(postObject, post_url, "client", method);
  };

  render() {
    return (
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header {...this.props} currentPage={"catalog-categories"} />
          <div className="layout-page">
            <Topmenu />
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row mb-3">
                  <div className="col-lg-10 col-md-6">
                    <h4 className="fw-bold">
                      {this.state.editID !== "" ? "Update" : "Add New"}{" "}
                      {moduleName}
                    </h4>
                  </div>
                  <div className="col-lg-2 col-md-6 text-end">
                    <Link to={modulePath}>
                      <button
                        type="button"
                        className="btn btn-outline-primary waves-effect"
                      >
                        Back
                      </button>
                    </Link>
                  </div>
                </div>
                <PostForm
                  {...this.props}
                  fields={this.state.clientdata}
                  btndisabled={this.state.btndisabled}
                  onChange={this.fieldChange}
                  onValid={this.handleSubmit}
                  sateValChange={this.sateValChange}
                  error_msg={this.state.error_msg}
                  outletList={this.state.outletList}
                  availabiltyList={this.state.availabiltyList}
                  onInvalid={() => {
                    console.log("Form invalid!");
                    setTimeout(function () {
                      if ($("#modulefrm .is-invalid").length > 0) {
                        $("html, body").animate(
                          {
                            scrollTop:
                              $(document)
                                .find("#modulefrm .is-invalid:first")
                                .offset().top - 100,
                          },
                          500
                        );
                      }
                    }, 500);
                  }}
                />
              </div>

              <Footer />
            </div>
          </div>
        </div>

        <div className="layout-overlay layout-menu-toggle"></div>
        <div className="drag-target"></div>
        <PageLoader pageloading={this.state.pageloading} />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    formpost: state.formpost,
    detaildata: state.detaildata,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFormPost: (formPayload, postUrl, authType, method) => {
      dispatch({ type: GET_FORMPOST, formPayload, postUrl, authType, method });
    },
    getDetailData: (datas) => {
      dispatch({ type: GET_DETAILDATA, datas });
    },
  };
};

export default connect(mapStateTopProps, mapDispatchToProps)(Form);

function validationConfig(props) {
  const { categoryName, categoryStatus } = props.fields;

  return {
    fields: ["categoryName", "categoryStatus"],

    validations: {
      categoryName: [[isEmpty, categoryName]],
      categoryStatus: [[isSingleSelect, categoryStatus]],
    },
  };
}

class PostForm extends Component {
  constructor(props) {
    super(props);
    this.setContent = this.setContent.bind(this);
    this.setContentLong = this.setContentLong.bind(this);
  }

  handleChange(name, value) {
    this.props.onChange(name, value);
  }
  handleSelectChange(name, value) {
    this.props.onChange(name, value);
  }

  handleCheckChange(name, value) {
    this.props.onChange(name, value.target.checked);
  }

  setContent(value, name) {
    this.props.onChange('categoryShortDescription', value);
  }
  setContentLong(value, name) {
     this.props.onChange('categoryLongDescription', value);
   }
  

  async uplaodFiles(imageType) {
    var loadID = "";
    var loadCont = "";
    if (imageType === "categoryImage") {
      loadID = "ImageContainer";
      loadCont = "ImageDetails";
    }
    this.props.sateValChange("btndisabled", true);
    showLoader(loadCont);
    showLoader(loadID);
    var imagefile = document.querySelector("#" + imageType);
    const file = imagefile.files[0];
    var fileDetail = await uploadFile(file, "category", "client");
    if (fileDetail.status === "ok") {
      this.props.onChange(imageType, fileDetail.url);
    }
    hideLoader(loadID);
    hideLoader(loadCont);
    $("#" + imageType).val("");
    this.props.sateValChange("btndisabled", false);
  }
  async removeImage(fileNamme, imageType) {
    var loadCont = "";
    if (imageType === "categoryImage") {
      loadCont = "ImageDetails";
    }
    showLoader(loadCont);
    var fileDetail = await removeFile(fileNamme, "client");
    if (fileDetail.status === "ok") {
      hideLoader(loadCont);
      this.props.onChange(imageType, "");
    }
  }

  handleChangeAvailDate(dayIndex, elementType, selectDate) {
    this.updateDayAvail(dayIndex, elementType, selectDate);
  }
  handleChangeCheck(dayIndex, elementType, event) {
    var value = event.target.checked === true ? "Yes" : "No";
    this.updateDayAvail(dayIndex, elementType, value);
  }
  updateDayAvail(dayIndex, elementType, value) {
    var categoryTimeAvailability = this.props.fields.categoryTimeAvailability;
    var updcategoryTimeAvailability = [];
    categoryTimeAvailability.map((item, index) => {
      if (index === dayIndex) {
        var start = item.start;
        var end = item.end;
        var checked = item.checked;
        if (elementType === "start") {
          start = value;
        } else if (elementType === "end") {
          end = value;
        } else if (elementType === "checked") {
          checked = value;
          start = "";
          end = "";
        }
        updcategoryTimeAvailability.push({
          day: item.day,
          checked: checked,
          start: start,
          end: end,
        });
      } else {
        updcategoryTimeAvailability.push(item);
      }
    });
    this.props.onChange("categoryTimeAvailability", updcategoryTimeAvailability);
  }
  render() {
    const { fields, onChange, onValid, onInvalid, $field, $validation } =
      this.props;
    let errMsgCatName,
      errMsgStatus = "";
    if ($validation.categoryName.error.reason !== undefined) {
      errMsgCatName = $validation.categoryName.show && (
        <span className="error">{$validation.categoryName.error.reason}</span>
      );
    }
    if ($validation.categoryStatus.error.reason !== undefined) {
      errMsgStatus = $validation.categoryStatus.show && (
        <span className="error">{$validation.categoryStatus.error.reason}</span>
      );
    }

    return (
      <form className="card fv-plugins-bootstrap5" id="modulefrm">
        <div className="card-body row g-3">
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className={
                  errMsgCatName !== "" &&
                  errMsgCatName !== false &&
                  errMsgCatName !== undefined
                    ? "form-control is-invalid"
                    : "form-control"
                }
                name="categoryName"
                value={fields.categoryName}
                {...$field("categoryName", (e) =>
                  onChange("categoryName", e.target.value)
                )}
              />
              <label htmlFor="categoryName">
                Category Name <span className="error">*</span>
              </label>
              {errMsgCatName}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className="form-control"
                id="categoryCustomTitle"
                name="categoryCustomTitle"
                value={fields.categoryCustomTitle}
                placeholder="Custom Name"
                aria-label="Text input with checkbox"
                {...$field("categoryCustomTitle", (e) =>
                  onChange("categoryCustomTitle", e.target.value)
                )}
              />
              <label
                className="select-box-label"
              >
                Custom Name
              </label>
            </div>
          </div>
          <div
            className="col-md-6"
          >
            <div className="form-floating form-floating-outline custm-select-box">
              <Select
                value={fields.categoryOutletID}
                onChange={this.handleSelectChange.bind(this, "categoryOutletID")}
                placeholder={"Select Outlet"}
                options={this.props.outletList}
                isClearable={true}
                isMulti
              />
              <label className="select-box-label">
                Outlet
              </label>
            </div>
          </div>          
          <div className="col-md-6">
            <div className="form-floating form-floating-outline custm-select-box">
              <Select
                value={fields.categoryAvailabilityID}
                onChange={this.handleSelectChange.bind(
                  this,
                  "categoryAvailabilityID"
                )}
                isMulti
                placeholder="Select Availabilty"
                options={this.props.availabiltyList}
                isClearable={true}
              />
              <label className="select-box-label">Availabilty</label>
            </div>
          </div>
          <div className="col-md-12">
            <label>Short Description</label>
            <Editor setContent={this.setContent} data={fields.categoryShortDescription} />
          </div>
          <div className="col-md-12">
            <label>Long Description</label>
            <Editor setContent={this.setContentLong} data={fields.categoryLongDescription} />
          </div>
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className="form-control"
                name="categorySequence"
                value={fields.categorySequence}
                {...$field("categorySequence", (e) =>
                  onChange("categorySequence", e.target.value)
                )}
              />
              <label htmlFor="categorySequence">Sequence</label>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className="form-control"
                name="categoryLeadTime"
                value={fields.categoryLeadTime}
                {...$field("categoryLeadTime", (e) =>
                  onChange("categoryLeadTime", e.target.value)
                )}
              />
              <label htmlFor="categoryLeadTime">Category Lead Time</label>
            </div>
          </div>
          <div
            className={
              errMsgStatus !== "" &&
              errMsgStatus !== false &&
              errMsgStatus !== undefined
                ? "col-md-6 error-select error"
                : "col-md-6"
            }
          >
            <div className="form-floating form-floating-outline custm-select-box">
              <Select
                value={fields.categoryStatus}
                onChange={this.handleSelectChange.bind(this, "categoryStatus")}
                placeholder="Select Status"
                options={[
                  { value: "A", label: "Active" },
                  { value: "I", label: "In Active" },
                ]}
                isClearable={true}
              />
              <label className="select-box-label">
                Status<span className="error">*</span>
              </label>
              {errMsgStatus}
            </div>
          </div>
          <div className="col-md-6"></div>
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <div className="mb-3" id="ImageContainer">
                <label htmlFor="formFile" className="form-label">
                  Image
                </label>
                <input
                  className="form-control"
                  type="file"
                  id="categoryImage"
                  onChange={(event) => {
                    this.uplaodFiles("categoryImage", event);
                    return false;
                  }}
                />
              </div>
            </div>
            {fields.categoryImage !== "" && fields.categoryImage !==null && (
              <div className="dz-preview dz-processing dz-image-preview dz-success dz-complete">
                <div className="dz-details" id="ImageDetails">
                  <div className="dz-thumbnail">
                    <img alt="" src={fields.categoryImage} />
                  </div>
                </div>
                <a
                  className="dz-remove"
                  href={void 0}
                  onClick={this.removeImage.bind(
                    this,
                    fields.categoryImage,
                    "categoryImage"
                  )}
                >
                  Remove file
                </a>
              </div>
            )}
          </div>
          <h1 className="display-6 mb-0">Time Availability</h1>
          {fields.categoryTimeAvailability.map((item, index) => {
            return (
              <div className="row" key={index}>
                <div className="col-md-1">
                  <div className="form-check form-check-inline mt-3">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="low_stock_alert"
                      checked={item.checked === "Yes" ? true : false}
                      onChange={this.handleChangeCheck.bind(
                        this,
                        index,
                        "checked"
                      )}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="low_stock_alert"
                    >
                      {item.day}
                    </label>
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="form-floating-outline mt-2 custm-date-box">
                    <DatePicker
                      className="form-control"
                      showTimeSelect
                      showTimeSelectOnly
                      timeIntervals={15}
                      timeCaption="Time"
                      dateFormat="h:mm aa"
                      selected={
                        item.start !== "" && item.start !== null
                          ? new Date(item.start)
                          : ""
                      }
                      onChange={this.handleChangeAvailDate.bind(
                        this,
                        index,
                        "start"
                      )}
                      disabled={item.checked === "Yes" ? false : true}
                    />
                    <label className="select-box-label">From</label>
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="form-floating-outline mt-2 custm-date-box">
                    <DatePicker
                      className="form-control"
                      showTimeSelect
                      showTimeSelectOnly
                      timeIntervals={15}
                      timeCaption="Time"
                      dateFormat="h:mm aa"
                      selected={
                        item.end !== "" && item.end !== null
                          ? new Date(item.end)
                          : ""
                      }
                      onChange={this.handleChangeAvailDate.bind(
                        this,
                        index,
                        "end"
                      )}
                      disabled={item.checked === "Yes" ? false : true}
                    />
                    <label className="select-box-label">To</label>
                  </div>
                </div>
              </div>
            );
          })}

          <div className="pt-1 pb-4 pt-1 text-end">
            <button
              type="button"
              disabled={this.props.btndisabled}
              className="btn btn-primary me-sm-3 me-1 waves-effect waves-light submit_frm"
              onClick={(e) => {
                e.preventDefault();
                if (!this.props.btndisabled) {
                  this.props.$submit(onValid, onInvalid);
                }
              }}
            >
              Submit
            </button>
            <Link to={modulePath}>
              <button
                type="reset"
                className="btn btn-label-secondary waves-effect"
              >
                Cancel
              </button>
            </Link>
          </div>
        </div>
      </form>
    );
  }
}
PostForm = validated(validationConfig)(PostForm);
